module.exports = __webpack_public_path__ + "static/media/15.c0ec13c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/15.jpg
// module id = 585
// module chunks = 0